import { render, staticRenderFns } from "./QuestionResolve.vue?vue&type=template&id=1f63e246&scoped=true&"
import script from "./QuestionResolve.vue?vue&type=script&lang=js&"
export * from "./QuestionResolve.vue?vue&type=script&lang=js&"
import style0 from "./QuestionResolve.vue?vue&type=style&index=0&id=1f63e246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63e246",
  null
  
)

export default component.exports